export const isLogin = false; // TODO: Need to Remove

// ENV Config
export const ENV_CONFIG = {
  APP_NAME: import.meta.env.VITE_APP_NAME || "manPowerX",
  AUTH_API_URL: import.meta.env.VITE_AUTH_API,
  EMPLOYEE_API_URL: import.meta.env.VITE_EMPLOYEE_API,
  COURSE_API: import.meta.env.VITE_COURSE_API,
  ORDER_API_URL: import.meta.env.VITE_ORDER_API,
  IMAGE_URL: import.meta.env.VITE_IMAGE_URL,
  NODE_ENV: import.meta.env.VITE_NODE_ENV || "development",
  FRONTEND_URL: import.meta.env.VITE_FRONTEND_URL,
};

// Date formats
export const DATE_FORMATS = {
  dbDate: "YYYY-MM-DD",
  displayDate: "DD MMM, YYYY",
  displayTime: "h:mm A",
  dbTime: "HH:mm:ss",
  rangePlaceholder: ["DD MMM, YYYY", "DD MMM, YYYY"],
} as const;

// Regex patterns
export const REGEX = {
  email:
    /^(?![-_.])[a-zA-Z0-9]+(?:[._-][a-zA-Z0-9]+)*@([a-zA-Z0-9]+(-[a-zA-Z0-9]+)*\.)+[a-zA-Z]{2,10}$/,
  userId: /^(?!.*[._-]{2})[a-zA-Z0-9]+([._-]?[a-zA-Z0-9])*$/,
};
